import dynamic from "next/dynamic";
// TODO: Please import ALL Modules dynamically see above components for example not this does not apply for Type Definitions
const Text = dynamic(() => import("./Text/Text"));
const TextMedia = dynamic(() => import("./TextMedia/TextMedia"));
const Media = dynamic(() => import("./Media/MediaModul"));
const Accordion = dynamic(() => import("./Accordion/Accordion"));
const InfoBoxesModule = dynamic(
  () => import("./InfoBoxModule/InfoBoxesModule"),
);
const IconGridModule = dynamic(() => import("./IconGridModule/IconGridModule"));
const Insta = dynamic(() => import("./Insta/Insta"));
const Timeline = dynamic(() => import("./Timeline/Timeline"));
const FactsGrid = dynamic(() => import("./Facts/Facts"));
const TeaserSliderModule = dynamic(() => import("./TeaserSlider/TeaserSlider"));
const FullWidthSlider = dynamic(
  () => import("./FullWidthSlider/FullWidthSlider"),
);
const ImageGridModule = dynamic(() => import("./ImageGrid/ImageGrid"));
const NewsLetter = dynamic(() => import("./NewsLetter/NewsLetter"));
const QuoteGridModule = dynamic(() => import("./QuotesGrid/QuotesGrid"));
const ZitateSlider = dynamic(
  () => import("./QuoteSliderModule/QuoteSliderModule"),
);
const LogoSliderModule = dynamic(
  () => import("./LogoSliderModule/LogoSliderModule"),
);
const EventGridModule = dynamic(() => import("./EventGrid/EventGrid"));
const PostsGridModule = dynamic(() => import("./PostGrid/PostGrid"));
const ImageSliderModule = dynamic(() => import("./ImageSlider/ImageSlider"));
const PostSliderModule = dynamic(() => import("./PostSlider/PostSlider"));
const EventSliderModule = dynamic(() => import("./EventSlider/EventSlider"));
const LogosGridModule = dynamic(() => import("./LogosGrid/LogosGrid"));
const TextMediaBig = dynamic(() => import("./TextMediaBig/TextMediaBig"));
const MediaBackground = dynamic(
  () => import("./MediaBackground/MediaBackground"),
);
const MagazinGrid = dynamic(() => import("./MagazinGrid/MagazinGrid"));
const GlossarGrid = dynamic(() => import("./GlossarGrid/GlossarGrid"));
const TeamGrid = dynamic(() => import("./TeamGrid/TeamGrid"));
const QuotesBanner = dynamic(() => import("./QuotesBanner/QuotesBanner"));
const Table = dynamic(() => import("./Table/Table"));
const GoogleMap = dynamic(() => import("./GoogleMap/GoogleMapModule"));
const FormBuilderModule = dynamic(() => import("./Form/FormModule"));
const CTA = dynamic(() => import("./CTA/CTA"));
const Contact = dynamic(() => import("./Contact/Contact"));
const LinkListModule = dynamic(() => import("./LinkListModule/LinkListModule"));
const BillettoLinkList = dynamic(
  () => import("./BillettoLinkList/BillettoLinkList"),
);
const MaterialOverview = dynamic(
  () => import("./MaterialOverview/MaterialOverview"),
);

import {
  HeadersOptionsType,
  ModuleOptionsType,
} from "@/types/ModuleOptionsType";
import { Module } from "../wp/types/acf-module-types";
import {
  NewsLetterOptionType,
  OptionsEndCardsType,
  OptionsFactsheetsType,
  OptionsGoogleMapType,
  OptionsHeaderType,
  OptionsSocialMediaType,
} from "@/types/OptionType";
import { getSingleModuleData } from "../getData/getModulData";
import { IsFirstModuleContext } from "@/context/IsFirstModuleContext";
import { IndexedPostSlidereData } from "../getData/getIndexedPostSliderData";
import { IndexedAccordionData } from "@/getData/getIndexedAccordionData";
import { PostGridCategories } from "../getData/getIndexedPostGridData";
import { TeaserSliderElementType } from "../components/TeaserCard/TeaserCard";
import { Header_Logos } from "@/wp/types/acf-header-types";
import { SingleImageSlider } from "@/modules/SingleImageSlider/SingleImageSlider";
import { IndexedFormsData } from "@/getData/getIndexedFormsData";
import { FileType, OptionsType } from "@/types/baseTypes";
import { BreakpointsOptionsType } from "@/getData/getBreakpoints";
import { FullWidthSliderDataType } from "@/getData/getFullWidthSliderData";
import { IndexedEventSliderData } from "@/getData/getIndexedEventSliderData";
import { QuotesElementType } from "./QuoteSliderModule/QuoteSliderModule";
import { IndexedNewsletterData } from "@/getData/getIndexedNewsletterData";
import { IndexedContactData } from "@/getData/getContactTeamData";
import { IndexedLinkListData } from "@/getData/getIndexedLinkListData";
import { IndexedMaterialOverviewData } from "@/getData/getIndexedMaterialOverviewData";
import { TextMediaDiagramDataType } from "@/getData/getTextMediaDiagramData";
import { SitemapGroup } from "@/getData/getSitemapData.ts";
import SitemapModule from "@/modules/SitemapModule/SitemapModule.tsx";
import { BilletoEventOverviewType } from "@/getData/fetchBillettoData";

// TODO never pass full options object to module only pass the options that are actually used with moduleOptions
interface ModulesProps {
  index: number;
  module: Module["module"][number];
  moduleOptions: ModuleOptionsType;
  breakpoints: BreakpointsOptionsType | null;
  insta: string;
  socialMedia: OptionsSocialMediaType;
  teaserSliderData: TeaserSliderElementType[];
  fullWidthSliderData?: FullWidthSliderDataType;
  newsletterOptions: NewsLetterOptionType;
  quotesSliderData: QuotesElementType[];
  logoElements: Header_Logos["header_logos"][];
  indexedEventSliderData: IndexedEventSliderData;
  indexedPostSliderData: IndexedPostSlidereData;
  indexedAccordionData: IndexedAccordionData;
  PostGridCategories: PostGridCategories;
  indexedNewsletterData: IndexedNewsletterData;
  isBigParagraph?: boolean;
  fallbackImages: OptionsHeaderType["fallback_images"];
  endCards: OptionsEndCardsType;
  headerOptions: HeadersOptionsType;
  googleMapThemeOptions: OptionsGoogleMapType;
  type: string;
  pageId: number;
  indexedFormsData: IndexedFormsData;
  formBulderOptions: OptionsType["acf"]["form_builder"];
  indexedContactData: IndexedContactData;
  indexedLinkListData: IndexedLinkListData;
  indexedMaterialOverviewData: IndexedMaterialOverviewData;
  metalCsvFile: FileType;
  textMediaDiagramData: TextMediaDiagramDataType[];
  mediaDiagramData: TextMediaDiagramDataType[];
  sitemapData: SitemapGroup[] | null;
  isNobleElements: boolean;
  billettoEventsData: BilletoEventOverviewType[] | null;
  factsheets: OptionsFactsheetsType;
}

export const Modules = (props: ModulesProps) => {
  const moduleContent = (() => {
    switch (props.module.acf_fc_layout) {
      case "text":
        return (
          <Text
            data={props.module}
            textOptions={props.moduleOptions.text!}
            isBigParagraph={props.isBigParagraph}
            isBlogPage={props.type === "blog"}
          />
        );
      case "media":
        const mediaDiagramData = props.mediaDiagramData.find(
          (d) => d.index === props.index,
        )?.data;
        return (
          <Media
            data={props.module}
            mediaOptions={props.moduleOptions.media!}
            metalCsvFile={props.metalCsvFile}
            diagramData={mediaDiagramData}
            isBlogPage={props.type === "blog"}
          />
        );
      case "textmedia":
        const diagramData = props.textMediaDiagramData.find(
          (d) => d.index === props.index,
        )?.data;
        return (
          <TextMedia
            data={props.module}
            textmediaOptions={props.moduleOptions.textmedia!}
            breakpoints={props.breakpoints}
            isBigParagraph={props.isBigParagraph}
            metalCsvFile={props.metalCsvFile}
            diagramData={diagramData}
            factsheets={props.factsheets}
          />
        );
      case "textmedia_big":
        return (
          <TextMediaBig
            data={props.module}
            textmediaBigOptions={props.moduleOptions.textmedia_big!}
            breakpoints={props.breakpoints}
          />
        );
      case "grid":
        return (
          <PostsGridModule
            data={props.module}
            postsGridOptions={props.moduleOptions.grid!}
            fallback_image={props.fallbackImages.header_posts}
            categories={props.PostGridCategories.categories}
            isNobleElements={props.isNobleElements}
          />
        );
      case "slider":
        //get data only if module is actually used at the current index to throw an error if module data is undefined and we can ensure that is exist from here on
        const postSliderData = getSingleModuleData(
          props.indexedPostSliderData,
          props.index,
        );
        if (!postSliderData) {
          console.warn(
            `[ModuleList] Data missing for slider at index ${props.index}`,
          );
          return null;
        }
        return (
          <PostSliderModule
            data={props.module}
            postsSliderOptions={props.moduleOptions.slider!}
            postSliderData={postSliderData}
            endCardData={props.endCards?.slider}
          />
        );
      case "accordion":
        const accordionData = props.indexedAccordionData.find(
          (d) => d.index === props.index,
        )?.data;
        return (
          <Accordion
            data={props.module}
            accordionOptions={props.moduleOptions.accordion!}
            index={props.index}
            accordionData={accordionData}
          />
        );
      case "image_slider":
        return (
          <ImageSliderModule
            data={props.module}
            imageSliderOptions={props.moduleOptions.image_slider!}
          />
        );
      case "infoboxes":
        return (
          <InfoBoxesModule
            data={props.module}
            infoBoxOptions={props.moduleOptions.infoboxes!}
          />
        );
      case "icon_grid":
        return (
          <IconGridModule
            data={props.module}
            infoBoxOptions={props.moduleOptions.icon_grid!}
          />
        );
      case "timeline":
        return (
          <Timeline
            data={props.module}
            timelineOptions={props.moduleOptions.timeline!}
          />
        );
      case "events_slider":
        //get data only if module is actually used at the current index to throw an error if module data is undefined and we can ensure that is exist from here on
        const eventSliderData = getSingleModuleData(
          props.indexedEventSliderData,
          props.index,
        );
        if (!eventSliderData) {
          console.warn(
            `[ModuleList] Data missing for events_slider at index ${props.index}`,
          );
          return null;
        }
        return (
          <EventSliderModule
            data={props.module}
            eventsSliderOptions={props.moduleOptions.events_slider!}
            eventSliderData={eventSliderData}
            endCardData={props.endCards?.events_slider}
          />
        );
      case "events_grid":
        return (
          <EventGridModule
            data={props.module}
            eventsGridOptions={props.moduleOptions.events_grid!}
          />
        );

      case "instagram":
        return (
          <Insta
            data={props.module}
            options={props.moduleOptions.instagram!}
            feed={props.insta}
            socialMedia={props.socialMedia}
          />
        );
      case "facts_grid":
        return (
          <FactsGrid
            data={props.module}
            factsGridOptions={props.moduleOptions.facts_grid!}
          />
        );
      case "teaser_slider":
        return (
          <TeaserSliderModule
            data={props.module}
            teaserSliderOptions={props.moduleOptions.teaser_slider!}
            teaserSliderData={props.teaserSliderData}
            metalCsvFile={props.metalCsvFile}
          />
        );
      case "fullwidth_slider":
        return (
          <FullWidthSlider
            data={props.module}
            fullWidthSliderData={props.fullWidthSliderData}
            fullWidthSliderOptions={props.moduleOptions.fullwidth_slider}
            breakpoints={props.breakpoints}
          />
        );
      case "image_grid":
        return (
          <ImageGridModule
            data={props.module}
            imageGridOptions={props.moduleOptions.image_grid!}
          />
        );
      case "newsletter":
        if (props.indexedNewsletterData.length > 0) {
          const newsletterData = getSingleModuleData(
            props.indexedNewsletterData,
            props.index,
          );
          if (!newsletterData) {
            console.warn(
              `[ModuleList] Data missing for newsletter at index ${props.index}`,
            );
            return null;
          }

          return (
            <NewsLetter
              data={props.module}
              newsletterOptions={props.newsletterOptions}
              nesletterTemplateOptions={props.moduleOptions.newsletter_options!}
              friendlyCaptchaApplicationkey={
                props.formBulderOptions.friendly_captcha_application_key || ""
              }
              newsletterData={newsletterData}
            />
          );
        } else {
          console.warn(
            `No newsletter data found for index ${props.index}. Please check your data source.`,
          );
          return null;
        }
      case "quotes_grid":
        return (
          <QuoteGridModule
            data={props.module}
            zitateGridOptions={props.moduleOptions.quotes_grid!}
            moduleIndex={props.index}
          />
        );
      case "quotes_slider":
        return (
          <ZitateSlider
            data={props.module}
            quotesSliderOptions={props.moduleOptions.quotes_slider!}
            quotesSliderData={props.quotesSliderData}
            index={props.index}
            endCardData={props.endCards?.quotes_slider}
          />
        );

      case "logos_slider":
        return (
          <LogoSliderModule
            data={props.module}
            logoSliderOptions={props.moduleOptions.logos_slider!}
            logoElements={props.logoElements}
          />
        );
      case "logos_grid":
        return (
          <LogosGridModule
            data={props.module}
            logosGridOptions={props.moduleOptions.logos_grid!}
          />
        );
      case "magazine_grid":
        return (
          <MagazinGrid
            fallbackImage={
              props.headerOptions.header_magazine?.show_fallback_image
                ? props.fallbackImages.header_magazine
                : undefined
            }
            data={props.module}
            magazinGridOptionsType={props.moduleOptions.magazine_grid!}
          />
        );
      case "glossary_grid":
        return (
          <GlossarGrid
            data={props.module}
            glossarGridOptions={props.moduleOptions.glossary_grid!}
            glossarHeaderOptions={props.headerOptions.header_glossar!}
          />
        );
      case "mediabackground":
        return (
          <MediaBackground
            data={props.module}
            mediaBackgroundOptions={props.moduleOptions.mediabackground!}
            breakpoints={props.breakpoints}
          />
        );

      case "team_grid":
        return (
          <TeamGrid
            data={props.module}
            gridOptions={props.moduleOptions.team_grid!}
            socialMedia={props.socialMedia}
            teamheaderOptions={props.headerOptions.header_team}
          />
        );
      case "quotes_banner":
        return (
          <QuotesBanner
            data={props.module}
            QuotesBannerOptions={props.moduleOptions.quotes_banner!}
          />
        );
      case "single_image_slider":
        return (
          <SingleImageSlider
            data={props.module}
            options={props.moduleOptions.single_image_slider!}
          />
        );
      case "tables":
        return (
          <Table data={props.module} options={props.moduleOptions.tables!} />
        );
      case "google_map":
        return (
          <GoogleMap
            data={props.module}
            googleMapOptions={props.moduleOptions.google_map!}
            googleMapThemeOptions={props.googleMapThemeOptions}
          />
        );
      case "formbuilder":
        const formData = getSingleModuleData(
          props.indexedFormsData,
          props.index,
        );
        if (!formData) {
          console.warn(
            `[ModuleList] Data missing for formbuilder at index ${props.index}`,
          );
          return null;
        }
        return (
          <FormBuilderModule
            formBulderOptions={props.moduleOptions.formbuilder!}
            data={props.module}
            formData={formData}
            friendlyCaptchaApplicationkey={
              props.formBulderOptions.friendly_captcha_application_key || ""
            }
          />
        );
      case "cta":
        return (
          <CTA
            data={props.module}
            CTAModuleOptions={props.moduleOptions.cta!}
          />
        );
      case "contact":
        const contactData = getSingleModuleData(
          props.indexedContactData,
          props.index,
        );
        if (!contactData) {
          console.warn(
            `[ModuleList] Data missing for contact at index ${props.index}`,
          );
          return null;
        }
        return (
          <Contact
            data={props.module}
            contactOptions={props.moduleOptions.contact!}
            contactData={contactData.data} // Ensure contactData is passed correctly
          />
        );
      case "linklist":
        if (props.billettoEventsData) {
          return (
            <BillettoLinkList
              billettoEvents={props.billettoEventsData}
              linkListData={props.module}
              linkListOptions={props.moduleOptions.link_list!}
            />
          );
        }

        return (
          <LinkListModule
            data={props.module}
            linkListOptions={props.moduleOptions.link_list!}
            isNobleElements={props.isNobleElements}
          />
        );
      case "metal_grid": {
        const materialOverviewData = getSingleModuleData(
          props.indexedMaterialOverviewData,
          props.index,
        );
        return (
          <MaterialOverview
            data={props.module}
            materialOverviewData={materialOverviewData}
            metalCsvFile={props.metalCsvFile}
            factsheets={props.factsheets}
          />
        );
      }
      case "sitemap": {
        if (props.sitemapData) {
          return (
            <SitemapModule
              data={props.module}
              sitemapContent={props.sitemapData}
              isNobleElements={props.isNobleElements}
            />
          );
        }
        return null;
      }
      default:
        return null;
    }
  })();

  return (
    <IsFirstModuleContext.Provider value={props.index === 0}>
      {moduleContent}
    </IsFirstModuleContext.Provider>
  );
};
